import React, {PropTypes, Component} from 'react'
import { Link, browserHistory } from 'react-router'
import classnames from 'classnames'
import __R, {userCan} from 'containers/__R';
import Tooltip from 'react-tooltip';
import locale from '../locale'

class ClassNameTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    classInfo: PropTypes.object.isRequired
  }

  render(){
    let {classInfo} = this.props
    let {className, classID, consumption_type} = classInfo

    return(
      <div className='class-status' >
        <button className='btn-link' onClick={()=>browserHistory.push('/class-detail/' + classID)} disabled={!userCan('read_class_detail')}>{className}</button>
        {!consumption_type &&
          <i className='fa icon-info-circled' data-tip data-for={toString(classID)}>
            <Tooltip
              id={toString(classID)}
              effect='solid'
              place='right'
              type='info'
              getContent={()=> { return __('We have upgraded our class functionality, please set class tuition fee to facilitate the statistics of tuition consumption', locale); }}
            />
          </i>
        }
      </div>
    )
  }
}


export default ClassNameTd



// WEBPACK FOOTER //
// ./src/containers/pages/Class/ClassTable/ClassNameTd.js